<template>
  <div @click="closeModal()" class="product-modal">
    <div v-on:click.stop class="product-modal-container no-scrollbar">
        <div class="close-container">
            <p class="closeIcon" @click="closeModal()">&lt; Back</p>
        </div>
        <div class="main-container">
            <div class="image-container">
                <VueSlickCarousel :infinite="true" :arrows="false" :slidesToShow="1" :slidesToScroll="1" :draggable="true" :dots="true">
                    <img class="main-image" v-for="image in product.images" :key="image.id" :src="image.src"/>
                </VueSlickCarousel>
            </div>
            <div class="information-container">
                <div class="ethos-container">
                    <span :class="badgeExtraClass(ethos)" v-for="ethos in ethosTags" :key="ethos">{{ethos}}</span>
                </div>
                <p v-if="showAlert" class="red-alert">
                    Please select your size.
                </p>
                <div v-if="isCustomHeader && variantOptions.length > 1">
                    <select v-model="selectedVariant" id="variantSelector">
                        <option v-for="variant in variantOptions" :key="variant.id" :value="variant">{{variant.title}}</option>
                    </select>
                </div>
                <div v-if="isCustomHeader && extraProperties.length > 0">
                    <select v-for="(property,i) in extraProperties" v-model="propertiesSelected[i]" @change="changeProperty($event,property)" id="variantSelector">
                        <option v-for="variant in property.values" :key="variant" :value="variant">{{variant}}</option>
                    </select>
                </div>
                <p class="main-title">{{ product.title }}</p>
                <button @click="goCheckout" v-if="(selectedProduct && product.id == selectedProduct.id)" class="happybox-button yellow" :class="isLoading ? 'isLoading' : ''">{{buttonText}}</button>
                <button @click="selectProduct(product)" v-else class="happybox-button white">Select</button>
                <p v-html="description" class="main-description"></p>
            </div>
        </div>
        <div class="next-step-instructions">
            <p>
                <strong>Next Step:</strong> 
                <span>
                    You’ll be asked to fill in your shipping and billing address, but no payment will be required. Please make sure to complete all steps to confirm your order. You’ll receive an order confirmation email once complete.
                </span>
            </p>
        </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
    data(){
        return{
            currentImage: null,
            selectedVariant: null,
            showAlert: false,
            propertiesSelected: [],
        }
    },
    components:{
        VueSlickCarousel
    },
    props:{
        product: Object,
        selectedProduct: Object,
        isLoading: Boolean,
        isCustomHeader: Boolean,
    },
    computed:{
        selectedImage(){
            if(!this.currentImage){
                return this.product.images[0].src;
            }
            else {
                return this.currentImage;
            }
        },
        imageQuantity(){
            return this.product.images.length;
        },
        currentMainImageIndex(){
            if(this.selectedImage){
                let index = this.product.images.findIndex(x => x.src == this.selectedImage)
                if(index > -1)
                    return index
            }

            return 0
        },
        buttonText(){
            return this.isLoading ? "loading..." : "Next"
        },
        ethosTags(){
            if(this.product){
                let tags = this.product.tags.split(",");
                var ethos = tags.filter(y => y.includes("Filter_Ethos"));
                ethos = ethos.map((x) => {
                    var currentEthos = x.replace("Filter_","").split("_")
                    return currentEthos[1]
                })
                return ethos;
            }

            return []
        },
        variantOptions(){
           return this.product.variants.filter(x => x.inventory_quantity > 0);
        },
        extraProperties(){
            if(this.product.tags.includes("Properties_")){
                let tags = this.product.tags.split(",");
                let propertiesTags = tags.filter(x => x.includes("Properties_"));

                return propertiesTags.map((x) => {
                    let splittedTag = x.split("_");
                    let values = splittedTag[splittedTag.length - 1].split("-");

                    return {name: splittedTag[1],values: values}
                })
            }

            return []
        },
        description(){
            if(this.product)
                return this.product.body_html;
            
            return '';
        },
    },
    methods:{
        selectImage(src){
            this.currentImage = src;
        },
        closeModal(){
            if(this.isLoading)
                return
            this.$emit("closemodal");
        },
        imageCarousel(next){
            if (next){
                if(this.currentMainImageIndex < this.product.images.length - 1)
                    this.currentImage = this.product.images[this.currentMainImageIndex + 1].src
                else
                    this.currentImage = this.product.images[0].src
            }
            else {
                if(this.currentMainImageIndex > 0)
                    this.currentImage = this.product.images[this.currentMainImageIndex - 1].src
                else
                    this.currentImage = this.product.images[this.product.images.length - 1].src
            }
        },
        selectProduct(product){
            if((this.isCustomHeader && this.selectedVariant == null && product.variants.length > 1) || (this.extraProperties.length > 0 && this.propertiesSelected.some(x => !x))){
                this.showAlert = true;
                return
            }
            this.showAlert = false;
            let productToSend = JSON.parse(JSON.stringify(product));
            if(this.isCustomHeader && this.variantOptions.length > 1){
                productToSend.variants = [this.selectedVariant];
            }
            this.$emit("selectproduct",productToSend);
        },
        goCheckout(){
            this.$emit("checkout")
        },
        badgeExtraClass(badge){
          switch(badge){
            case "Women Owned":
              return "pink";
            case "Small Biz":
              return "green"
            case "BIPOC Owned":
              return "yellow"
            case "Sustainable":
              return "dgreen"
            case "Admin Professionals Day":
              return "lyellow"
            default:
              return '';
          }
        },
        changeProperty(event,properties){
            this.$emit("changevariant",{name:properties.name,value:event.target.value});
        }
    },
    mounted(){
        if(this.isCustomHeader){
            if(this.product.tags.includes("Properties_")){
                let tags = this.product.tags.split(",");
                let propertiesTags = tags.filter(x => x.includes("Properties_"));

                let properties = propertiesTags.map((x) => {
                    let splittedTag = x.split("_");
                    let values = splittedTag[splittedTag.length - 1].split("-");

                    return {name: splittedTag[1],values: values}
                })
                for(let property of properties){
                    this.propertiesSelected.push(null);
                }
            }
        }
    }

}
</script>

<style scoped>
 .product-modal{
    background-color: #0000004d!important;
    display: block;
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding: 45px 0;
 }

 .product-modal-container{
    width: 35%;
    max-height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    overflow-y: scroll;
    border: 1px solid #A8B5E0;
 }

 .product-modal-container .main-container{
    padding: 0% 5%;
    width: 100%;
    margin-bottom: 5%;
 }

 .product-modal-container .next-step-instructions{
    background-color: #d6f0fb;
    font-size: 0.8vw;
    padding: 5%;
    position: sticky;
    bottom: 0;
 }

 .image-container{
    width: 100%;
    height: auto;
    position: relative;
    display: flex;
    flex-direction: column;
 }

 .image-container .main-image{
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    background-color: #f6f6f6;
 }

 .arrow-right, .arrow-left{
    position: absolute;
    top: 38%;
    font-size: 2.5vw;
    color: #000;
}

.arrow-right{
    right: 2%;
}

.arrow-left{
    left: 2%;
}

 .extra-images-container {
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.extra-image{
    width: 15%;
    margin: 0% 2.5%;
    background-color: #f6f6f6;
}

.extra-image.selected{
    border: 1px solid black;
}

 .information-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
 }

 .information-container button{
    width: 100%;
    border: 1px solid #CFCED8!important;
 }

 .main-title{
    font-size: 1.5vw;
    color: #0f0c38;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 0;
    text-align: center;
    margin-top: 4%;
 }

 .main-description{
    margin-top: 5%;
    background-color: #f6f6f6;
    padding: 10px;
    font-size: 1vw;
    color: #0f0c38;
    max-height: 100%;
    overflow-y: scroll;
    width: 100%;
    min-height: 40%;
 }

 .close-container{
    position: sticky;
    top: 0%;
    right: 0%;
    left: 0%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 2% 5%;
    align-items: center;
    z-index: 1;
    background-color: white;
 }

.closeIcon{
    cursor: pointer;
    color: #0f0c38;
    font-size: 1.15vw;
    line-height: 1;
    width: auto;
}

.back{
    cursor: pointer;
    color: #0f0c38;
    font-size: 1.5vw;
    line-height: 1;
    font-weight: bold;
}

.happybox-button{
    margin-top: 5%;
}

.ethos-container{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    padding: 4% 0% 0%;
}

.ethos-container span{
    background: #ffeede;
    border-radius: 4px;
    padding: 4px 8px;
    color: #5981d9;
    font-weight: bold;
    font-size: 1.1vw;
    line-height: 1.3;
    margin-right: 3%;
}

.ethos-container .green{
  background-color: #d8efdf;
}

.ethos-container .yellow{
  background-color: #ffe7c7;
}

.ethos-container .dgreen{
  background-color: #a9ffbd;
}

.ethos-container .lyellow{
  background-color: #fffcdd;
}

.red-alert{
    font-size: 1.15vw;
    color: red;
}

@media only screen and (max-device-width: 767px){
    .product-modal-container{
        width: 90%;
        height: auto;
        overflow: scroll;
        flex-direction: column;
        justify-content: normal;
    }

    .close-container{
        position: sticky;
        position: sticky;
        top: -2%;
        z-index: 1;
    }

    .closeIcon{
        font-size: 3.5vw;
    }

    .back{
        font-size: 3.5vw;
    }

    .image-container{
        width: 100%;
    }

    .arrow-right, .arrow-left{
        top: 40%;
        font-size: 6.5vw;
    }

    .extra-images-container{
        margin-top: 5%;
    }

    .information-container{
        margin: 5% 0%;
        width: 100%;
        height: auto;
        text-align: center;
    }

    .main-title{
        font-size: 5vw;
    }

    .main-description{
        font-size: 3vw;
    }

    .ethos-container span{
        font-size: 3vw;
    }

    .red-alert{
        font-size: 3vw;
        color: red;
    }

    .product-modal-container .next-step-instructions{
        font-size: 3vw;
    }

    .information-container button{
        margin-top: 0;
    }
}

</style>